import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

interface ErrorDialogProps {
  open: boolean;
  error: string | null;
  onRetry: () => void;
  onClose: () => void;
}

export const ErrorDialog = ({
  open,
  error,
  onRetry,
  onClose,
}: ErrorDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ExclamationCircleIcon className="text-red-500" />
        <Typography variant="h6" color="error.main">
          Error
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1">{error}</Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        <Button onClick={onRetry} variant="contained" color="error">
          Try Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};
